import React from "react";
import MapView from "./Map";
import { LocationDetail } from "@/types";

interface LocationComponentProps {
  locations: LocationDetail[];
  height: number;
  type?: "accommodation" | "experience";
  locationDetails?: any;
}

const LocationComponent: React.FC<LocationComponentProps> = ({
  locations,
  height,
  type = "experience",
  locationDetails,
}) => {
  // Get the first valid location
  const location = locations[0];

  if (!location) {
    return null;
  }

  return (
    <div className="w-full flex flex-col items-start justify-start">
      {location?.coordinates ? (
        <div className="w-full px-1">
          <p className="text-neutral-700 font-light text-[13px] leading-relaxed mb-4">
            {type === "experience"
              ? location.description ||
                "Please refer to the map below for location details."
              : `This accommodation is located on ${location.description}.`}
          </p>

          {location.coordinates.latitude && location.coordinates.longitude ? (
            <div style={{ width: "100%", height: `${height}px` }}>
              <MapView
                type="viator-experience"
                latitude={location.coordinates.latitude}
                longitude={location.coordinates.longitude}
                markerName={locationDetails?.title}
              />
            </div>
          ) : (
            <p className="text-neutral-700 font-light text-[13px] leading-relaxed">
              Coordinates not available for this location.
            </p>
          )}
        </div>
      ) : (
        <p className="text-neutral-700 font-light text-[13px] leading-relaxed">
          Location details not available.
        </p>
      )}
    </div>
  );
};

export default LocationComponent;
